export default {
  "b2b.zadosti-odbaveni-widget.label": "Odbavení žádosti",
  "b2b.zadosti-odbaveni-widget.message-empty": "Žádné žádosti k odbavení."
};
